// Table names
export const CRONJOB_RESULT_TABLE = "cronjob_result";
export const COMPANY_JOBFILE_TABLE = "company_jobfile";
export const JOB_LOCATION_JOBFILE_TABLE = "job_location_jobfile";
export const JOB_JOBFILE_TABLE = "job_jobfile";
export const ZIPCODE_TABLE = "zipcode";
export const JOB_SEEKER_TABLE = "job_seeker";
export const JOB_SEEKER_MARKER_TABLE = "job_seeker_marker";
export const JOB_SUGGESTION_MARKER_JOBFILE_TABLE = "job_suggestion_marker_jobfile";
export const JOB_SUGGESTION_JOBFILE_TABLE = "job_suggestion_jobfile";
export const JOB_SUGGESTION_SEEKER_JOBFILE_TABLE = "job_suggestion_seeker_jobfile";
export const JOB_MARKER_JOBFILE_TABLE = "job_marker_jobfile";
export const MATCH_JOBFILE_TABLE = "match_jobfile";
export const MATCH_NOTIFICATION_JOBFILE_TABLE = "match_notification_jobfile";
export const SEGMENT_JOBFILE_TABLE = "segment_jobfile";
export const MAT_JOB_JOBFILE_TABLE = "mat_job_jobfile";

// Storage Bucket names
export const PROFILE_PICTURE_BUCKET = "profile_picture";

// Values
export const JOBMATE_IK_ME_USER_ID = "2679a223-5bb6-4d57-be4a-68a87dcbf8b2";
export const JOBMATE_CYPRESS_IK_ME_USER_ID = "d0b058e2-d757-43d8-a3c1-be1d834e2705";

// Other
export const INFINITY_IN_SECONDS = 99 * 365 * 24 * 60 * 60; // 99 years in seconds
